export default __webpack_public_path__ + "static/media/mianji.4ad1a447.png";